<template>
  <div>
    <EditableList
      ref="list"
      :list="discounts"
      :pending="pending"
      :form-add-title="$t('shop.discounts.addDiscount')"
      :form-edit-title="$t('shop.discounts.editDiscount')"
      sticky
      width="500"
      @submit="$refs.form.submit()"
      @remove="$refs.form.remove()"
    >
      <template #listElement="{ row }">
        <div
          class="d-flex align-items-center justify-content-between w-100"
          style="overflow: hidden"
        >
          <span class="text-truncate">
            {{ row.name }}
          </span>
        </div>
      </template>

      <template #form="{ edited }">
        <DiscountForm
          v-if="edited === -1"
          ref="form"
          :pending.sync="pending"
          :discount="getDiscount(edited)"
          :catalog-id="catalog.id"
          @close="$refs.list.close()"
          @refresh="request"
        />
        <DiscountForm
          v-else
          ref="form"
          :pending.sync="pending"
          :discount="getDiscount(edited)"
          :catalog-id="catalog.id"
          @close="$refs.list.close()"
          @refresh="request"
          @add="discounts.push($event)"
          @open="$refs.list.toggle($event)"
        />
      </template>
    </EditableList>
  </div>
</template>

<script>
import EditableList from '@/components/settings/EditableList';
import { mapActions, mapGetters } from 'vuex';
import DiscountForm from './DiscountForm';

export default {
  props: {
    catalog: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    pending: false,
  }),
  components: {
    EditableList,
    DiscountForm,
  },
  computed: {
    ...mapGetters('shop', ['discounts']),
  },
  methods: {
    ...mapActions('shop', ['getDiscounts']),
    request() {
      this.pending = true;
      this.getDiscounts({ params: { catalogId: this.catalog.id } })
        .finally(() => {
          this.pending = false;
        });
    },
    getDiscount(id) {
      if (id === -1) {
        return {
          name: '',
          condition: '',
          payerCondition: '',
          applyToPast: false,
          priceModifier: '',
        };
      }
      return this.discounts.find((d) => d.id === id) || {};
    },
  },
  created() {
    this.request();
  },
};
</script>
